import {Component} from "@angular/core";
import {NavController} from 'ionic-angular';
import {HowToPage} from '../how-to/how-to';

@Component({
  templateUrl: 'build/pages/welcome/welcome.html'
})

export class WelcomePage {
  constructor(private nav: NavController) {
    this.nav = nav;
  }

  nextPage(){
    this.nav.setRoot(HowToPage, {}, {animate: true, direction: 'forward'});
  }
}
